import * as React from "react";

const SendMessageIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#fff"
            d="M12.5 28V12l19 8zm2-3 11.85-5-11.85-5v3.5l6 1.5-6 1.5zm.037 0V15z"
        ></path>
    </svg>
);

export default SendMessageIconSVG;
